import { useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from '@mui/styles';
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { translate } from '@openclassrooms/translations';
import { visuallyHidden } from '@mui/utils';

const useStyles = makeStyles(({ palette }) => ({
  video: {
    position: 'absolute',
    border: 'none',
    width: '100%',
    height: '100%',
    zIndex: 1,
  },
  closeBtn: {
    right: 0,
    position: 'absolute',
    zIndex: 3,
    color: palette.background.default,
  },
}));

export interface VimeoPlayerProps {
  id: number;
  onClose: () => void;
  isOpened: boolean;
  title: string;
}

function VimeoPlayer({ id, title }: Partial<VimeoPlayerProps>) {
  const videoRootRef = useRef<HTMLIFrameElement>(null);
  const classes = useStyles();

  return (
    <iframe
      title={title}
      ref={videoRootRef}
      src={`https://player.vimeo.com/video/${id}?autoplay=1`}
      className={classes.video}
    />
  );
}

function VimeoPlayerOuter({ title, onClose, id, isOpened }: VimeoPlayerProps) {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpened}
      onClose={onClose}
      fullScreen
      PaperProps={{
        style: {
          background: 'none',
          boxShadow: 'unset',
          margin: 0,
          padding: 0,
        },
      }}
    >
      <Box sx={visuallyHidden}>
        <DialogTitle>{title}</DialogTitle>
      </Box>

      <VimeoPlayer id={id} title={title} />

      <IconButton
        onClick={onClose}
        aria-label={translate('global.word.close_video')}
        className={classes.closeBtn}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
}

export default VimeoPlayerOuter;
